import { render, staticRenderFns } from "./SystemsReview.vue?vue&type=template&id=65b664ec&"
import script from "./SystemsReview.vue?vue&type=script&lang=js&"
export * from "./SystemsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports